import React from "react";
import Estig from './estig.png';
import FreeSoud from './Freesound_project_website_logo.png';
import ReactMarkdown from "react-markdown";

function Footer() {
    const markdown = '[![Netlify Status](https://api.netlify.com/api/v1/badges/d939ec8a-09ff-4525-88d7-f10997ad1aec/deploy-status)]' +
        '(https://app.netlify.com/sites/soundexplorer/deploys)';
    return (

        <div className="Footer container bg-light bottom p-4">
            <div className="row">
                <div className="col-sm">
                    <h5 className="text-muted">Powered By:</h5>
                    <br/>
                    <p><a href="https://freesound.org/" target="_blank" rel="noopener noreferrer"><img src={FreeSoud}
                                                                                                       alt=""/></a></p>
                    <p><small><a href="https://www.upf.edu/web/mtg" target="_blank"
                                 rel="noopener noreferrer">Music Technology Group</a></small></p>
                    <p><small><a href="http://www.upf.edu/" target="_blank"
                                 rel="noopener noreferrer">Universitat Pompeu Fabra</a></small></p>
                    <p><small><a href="https://freesound.org/" target="_blank"
                                 rel="noopener noreferrer">Free Sound API</a></small></p>
                </div>
                <div className="col-sm text-muted">
                    <h5>Developed By:</h5>
                    <br/>
                    <small><strong>Student:</strong><em><p>Duarte Cancela nº13683</p></em></small>
                    <small><strong>Teacher:</strong><em><p>Luis Carlos da Silva Bruno</p></em></small>
                    <hr/>
                    <div className="text-center"><ReactMarkdown source={markdown}/></div>
                    <div className="text-center">
                        <a href="https://www.w3.org/WAI/WCAG2A-Conformance" target="_blank"
                           rel="noopener noreferrer"
                           title="Explanation of WCAG 2.0 Level A Conformance">
                            <img height="32" width="88" src="https://www.w3.org/WAI/wcag2A" alt="Level A conformance,
                        W3C WAI Web Content Accessibility Guidelines 2.0"/></a></div>
                </div>
                <div className="col-sm text-center">
                    <a href="https://www.ipbeja.pt/" target="_blank" rel="noopener noreferrer"><img src={Estig} alt=""/></a>
                    <p><small><a href="https://www.ipbeja.pt/cursos/estig-ei/Paginas/default.aspx" target="_blank"
                                 rel="noopener noreferrer">Licenciatura
                        Engenharia Informática</a></small></p>
                    <p className="text-muted"><small><em>Tecnologias para a Web e Dispositivos Móveis</em></small></p>
                </div>
            </div>
        </div>
    );
}

export default Footer;